import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { resolveVenueSlug } from '@/lib/venue';
import type { Venue } from '@/types/venue';

type State =
  | { status: 'loading' }
  | { status: 'ready'; venue: Venue }
  | { status: 'error'; error: string };

export function useVenue(): State {
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    const slug = resolveVenueSlug();

    api
      .get<Venue>(`/api/v1/venues/by-slug/${slug}`)
      .then((res) => {
        if (!cancelled) setState({ status: 'ready', venue: res.data });
      })
      .catch((err) => {
        if (!cancelled) {
          const msg = err.response?.data?.detail ?? err.message ?? 'Error desconocido';
          setState({ status: 'error', error: msg });
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
